import React from 'react';
import moment from 'moment';
import ApplicationPremiumSettingsRevisionsModal from './applicationPremiumSettingsRevisionsModal';
import Step1 from "./WizardSteps/step1";
import Step2 from "./WizardSteps/step2";
import Step3 from "./WizardSteps/step3";
import Step5 from "./WizardSteps/step5";
import '../../style/dots.css';
import { LEGAL_ADVICE_TEXT } from '../../helpers/variables';
import { Link, Loader, Button, HorizontalRule, Heading, Alert, FormGroup, NavigationBar, NavigationContent, List } from 'arag-ui-lib';
import { PRIMARY, DOTS, QUATERNARY, LEFT, SUBMIT, ERROR, TERTIARY, MEDIUM, RIGHT, HEADING_3, HEADING_2, WIZARD, MOMENT_DATE_TIME_FORMAT } from '../../helpers/constants';
import CONTENT_STRINGS from '../../helpers/contentStrings';
import { FORM_GROUP_VARIANTS } from '../../helpers/formGroupVariants';
import SharedStep6 from './WizardSteps/sharedStep6';
import SharedStep4 from './WizardSteps/sharedStep4';
import { isAragUser, formatSolicitorOptionLabel } from '../../helpers/functions';
import Tooltip from '../General/tooltip';

const PremiumSettingsWizard = (props) => {
    const {
        premiumSettingsWizard,
        fetchingDamages,
        fetchingStages,
        fetchingCaseTypes,
        showTable,
        isApplicationPremium,
        isPercentagePremium,
        selectedCaseType,
        changeWizardStep,
        decimalErrors,
        checkDecimal,
        displayedCoverageType,
        displayedDeductible,
        displayedEndorsement,
        appPremiumSettingsIndicator,
        isChangingStatusOfApp,
        handleSubmitStep6,
        onApplicationPremiumEdit,
        pig,
        onApplyPig,
        onCancelAppPremiumSettings,
        selectedSolicitorGroupName,
        selectedSolicitorGroupAragProvider,
        selectedWorksourceName,
        selectedSubCaseType,
        steps,
        caseStages,
        handleCaseStagesSelectMultipleChange,
        handleCaseStagesCheckedState,
        showNonContingentToggle,
        hasNonContingentPremium,
        handleToggleNonContingent,
        handleNonContingentCaseStagesChange,
        handleNonContingentCaseStagesCheckedState,
        getEndDamageBands,
        getStartDamageBands,
        setDamageBand,
        removeDamageBand,
        getDamageBandName,
        changeStoreSettings,
        removeSolicitor,
        addSolicitor,
        solicitorGroupAragProviderId,
        lawsysFirms,
        changeLawsysFirmState,
        onSuggestionSelected,
        onSuggestionChange,
        validationMessage,
        premiumSettingTypeCustom,
        commissionAddDisabled,
        selectedCoverageType,
        selectedDeductible,
        selectedEndorsement,
        coveragesOptions,
        deductiblesOptions,
        endorsementsOptions,
        handleSubmit,
        applicationPremiumSaveButtonLabel,
        applicationPremiumCancelHandler,
        handleCancelWizard,
        failedToFetchMessage,
        sortDamageBands,
        currentStep,
        columns,
        topHeader,
        verticalHeaders,
        outerVerticalHeaders,
        groups,
        data,
        editableColumns,
        loiTestId,
        notesTestId,
        commentsTestId,
        endorsementsTestId,
        tableTestId,
        highlightedColumnsToUse,
        navItems,
        wizardLoiTestId,
        wizardNotesTestId,
        wizardCommentsTestId,
        wizardEndorsementsTestId,
        wizardTableTestId,
        validFromLabel,
        loggedInUser,
        highlightedRows,
        applicationPremiumSettingsRevisions,
        openModal,
        setOpenModal,
        selectedPreviousUpdate,
        setSelectedPreviousUpdate,
        revisionTableProps,
        appPremiumSettingsHistoryItemData,
        appPremiumSettingsHighlightedFields,
        appPremiumSettingsShowTableData,
        appPremiumSettingsEmphasizedFields,
        deductiblesTestId,
        coverageTestId,
        wizardCoverageTestId,
        wizardDeductiblesTestId,
        nonContingentLocked,
    } = props;
    
    const canEditApplicationPremiumSettings = loggedInUser?.allowedToEditApplicationPremiumSettings ?? false;
    const isAragUserLoggedIn = isApplicationPremium ? isAragUser(loggedInUser?.roles) : false;
    // WI 95280: Application Premium Settings become read-only once a PIG request has been sent. The `pig`
    // prop is already sourced from the selected application by premiumSettingsWizardHOC, so it is reused
    // here rather than reaching into the store again; it is undefined outside the policy context.
    const pigLocked = !!pig?.alreadyApplied;

    if(failedToFetchMessage){
        return <Alert variant={ERROR} label={failedToFetchMessage} />
    }

    if (premiumSettingsWizard.fetchingStepMessages || fetchingDamages || fetchingStages || fetchingCaseTypes
        || (premiumSettingsWizard.tableData.length > 0 && premiumSettingsWizard.damageBands.length === 0 && showTable)
        || (premiumSettingsWizard.fetchingExistingPremium)
    ) {
        return (
            <div className="col-sm-12">
                <div className="col-sm-5"></div>
                <Loader variant={DOTS} dotSize={MEDIUM}/>
            </div>
        )
    }
    if(showTable){
        return(
            <div>
                {
                    isApplicationPremium
                    ?
                        <Heading
                            variant={HEADING_3}
                            title={CONTENT_STRINGS.APPLICATION_PREMIUM_SETTINGS}
                            headingTestId={'application-premium-settings-section-header'}
                        />
                    :
                        null
                }
                <form className="form-horizontal premiumSettingsWizard-formWrapper" >
                    {/* Shared component for Step6 and PercentageStep6 */}
                    <SharedStep6
                        badResponseMsg={premiumSettingsWizard.badResponseMsg}
                        posting={premiumSettingsWizard.posting}
                        limitOfIndemnity={premiumSettingsWizard.limitOfIndemnity}
                        recoverableRatePercentage={premiumSettingsWizard.recoverableRatePercentage}
                        notes={premiumSettingsWizard.notes}
                        endorsements={premiumSettingsWizard.endorsements}
                        comments={premiumSettingsWizard.comments}
                        currentStep={showTable ? 6 : currentStep}
                        displayedCoverageType={displayedCoverageType}
                        displayedDeductible={displayedDeductible}
                        displayedEndorsement={displayedEndorsement}
                        isApplicationPremium={isApplicationPremium}
                        isPercentagePremium={isPercentagePremium}
                        topHeader={topHeader}
                        groups={groups}
                        columns={columns}
                        data={appPremiumSettingsShowTableData ?? data}
                        verticalHeaders={verticalHeaders}
                        patching={premiumSettingsWizard.patching}
                        appPremiumSettingsIndicator={appPremiumSettingsIndicator}
                        showTable={showTable}
                        stepMessages={premiumSettingsWizard.stepMessages}
                        loiTestId={loiTestId}
                        notesTestId={notesTestId}
                        commentsTestId={commentsTestId}
                        endorsementsTestId={endorsementsTestId}
                        tableTestId={tableTestId}
                        highlightedColumns={highlightedColumnsToUse}
                        outerVerticalHeaders={outerVerticalHeaders}
                        validFromLabel={validFromLabel}
                        highlightedRows={highlightedRows}
                        emphasizedFields={appPremiumSettingsEmphasizedFields}
                        deductiblesTestId={deductiblesTestId}
                        coverageTestId={coverageTestId}
                    />
                    {
                        isApplicationPremium
                        ?
                            <div>
                                {
                                    isChangingStatusOfApp
                                    ?
                                        <div className="btn-wrapper">
                                            <Button
                                                onClick={handleSubmitStep6}
                                                variant={PRIMARY}
                                                label={CONTENT_STRINGS.SAVE_AND_GO_LIVE}
                                                buttonTestId={'application-premium-save-changes'}
                                                arrowDirection={RIGHT}
                                                disabled={premiumSettingsWizard.patching}
                                            />
                                        </div>
                                    :
                                        null
                                }
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    {
                                        (canEditApplicationPremiumSettings && !pigLocked) && (
                                            <div className="btn-wrapper">
                                                <Button
                                                    onClick={onApplicationPremiumEdit}
                                                    variant={QUATERNARY}
                                                    label={CONTENT_STRINGS.EDIT}
                                                    buttonTestId={'application-premium-edit-button'}
                                                    arrowDirection={RIGHT}
                                                    disabled={premiumSettingsWizard.patching}
                                                />
                                            </div>
                                        )
                                    }
                                    {
                                        // WI 95280: tooltip in place of the hidden Edit button. Also gated on
                                        // canEditApplicationPremiumSettings so users who never had the button see no change.
                                        (canEditApplicationPremiumSettings && pigLocked)
                                        ?
                                            <div className="btn-wrapper">
                                                <Tooltip text={CONTENT_STRINGS.PIG_APPLIED_EDIT_LOCKED_TOOLTIP} />
                                            </div>
                                        :
                                            null
                                    }
                                    {
                                        (isAragUserLoggedIn && pig && pig.applicable)
                                        ?
                                            <div className="btn-wrapper" style={{ marginLeft: 'auto' }}>
                                                <Button
                                                    onClick={onApplyPig}
                                                    variant={PRIMARY}
                                                    label={CONTENT_STRINGS.APPLY_PREMIUM_INDEMNITY_GUARANTEE}
                                                    buttonTestId={'application-premium-apply-pig'}
                                                    arrowDirection={RIGHT}
                                                    disabled={!pig.enabled}
                                                    info={pig.disabledReason || ''}
                                                />
                                            </div>
                                        :
                                            null
                                    }
                                </div>
                                {
                                    isAragUserLoggedIn && applicationPremiumSettingsRevisions.length > 0
                                    ?
                                        <div className='col-sm-12'>
                                            <Heading 
                                                variant={HEADING_3}
                                                title={CONTENT_STRINGS.PREVIOUS_UPDATES}
                                                headingTestId={'application-premium-previous-updates-header'}
                                            />
                                            <List
                                                id="applicationPremiumSettings-PreviousUpdates-list"
                                                items={applicationPremiumSettingsRevisions.map((update, index) => ({
                                                    content: (
                                                        <Link
                                                            variant={TERTIARY}
                                                            key={index}
                                                            onClick={() => {
                                                                setSelectedPreviousUpdate(update);
                                                                setOpenModal(true);
                                                            }}
                                                            label={moment(update.revisionDate ?? update.createdDate).format(MOMENT_DATE_TIME_FORMAT)}
                                                            linkTestId={`application-premium-previous-update-${index}`}
                                                        />
                                                    ),
                                                }))}
                                            />
                                            {
                                                selectedPreviousUpdate
                                                ?
                                                    <ApplicationPremiumSettingsRevisionsModal
                                                        isOpen={openModal}
                                                        onClose={() => setOpenModal(false)}
                                                        revision={selectedPreviousUpdate}
                                                        revisionTableProps={revisionTableProps}
                                                        isPercentagePremium={isPercentagePremium}
                                                        appPremiumSettingsIndicator={appPremiumSettingsIndicator}
                                                        isApplicationPremium={isApplicationPremium}
                                                        appPremiumSettingsHistoryItemData={appPremiumSettingsHistoryItemData}
                                                        revisionIndex={applicationPremiumSettingsRevisions.indexOf(selectedPreviousUpdate)}
                                                        appPremiumSettingsHighlightedFields={appPremiumSettingsHighlightedFields}
                                                        appPremiumSettingsEmphasizedFields={null}
                                                    />
                                                :
                                                    null
                                            }
                                        </div>
                                    :
                                        null
                                }
                                {
                                    isChangingStatusOfApp
                                    ?
                                        <Link
                                            variant={TERTIARY}
                                            label={CONTENT_STRINGS.CANCEL}
                                            arrowDirection={LEFT}
                                            onClick={onCancelAppPremiumSettings}
                                            linkTestId={'edit-application-premium-setting-cancel-go-live'}
                                            disabled={premiumSettingsWizard.patching}
                                        />
                                    :
                                        null
                                }
                            </div>
                        :
                            null
                    }
                </form>
            </div>
        )
    }

    return (
        <div className="row">
            <div className="col-sm-12">
                <Heading
                    variant={HEADING_2}
                    title={premiumSettingsWizard.isEditMode ? CONTENT_STRINGS.EDIT_PREMIUM_SETTING : CONTENT_STRINGS.CREATE_PREMIUM_SETTING}
                    headingTestId={'edit-application-premium-setting-header'}
                />
                <form className="form-horizontal">
                    {
                        selectedSolicitorGroupName
                        ?
                            <FormGroup
                                labelSize={"col-sm-3"}
                                inputSize={"col-sm-6"}
                                label={`${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.GROUP}`}
                                variant={FORM_GROUP_VARIANTS.PLAIN}
                                inputProps={{
                                    id: 'selectedSolicitorGroupName',
                                    name: 'selectedSolicitorGroupName',
                                    label: formatSolicitorOptionLabel({ label: selectedSolicitorGroupName, aragProvider: selectedSolicitorGroupAragProvider }),
                                }}
                            />
                        :
                            null
                    }
                    {
                        selectedWorksourceName
                        ?
                            <FormGroup
                                labelSize={"col-sm-3"}
                                inputSize={"col-sm-6"}
                                label={CONTENT_STRINGS.WORK_SOURCE}
                                variant={FORM_GROUP_VARIANTS.PLAIN}
                                inputProps={{
                                    id: 'selectedWorksourceName',
                                    name: 'selectedWorksourceName',
                                    label: selectedWorksourceName
                                }}
                            />
                        :
                            null
                    }
                    {
                        selectedCaseType
                        ?
                            <FormGroup
                                labelSize={"col-sm-3"}
                                inputSize={"col-sm-6"}
                                label={CONTENT_STRINGS.CASE_TYPE}
                                variant={FORM_GROUP_VARIANTS.PLAIN}
                                inputProps={{
                                    id: 'selectedCaseType',
                                    name: 'selectedCaseType',
                                    label: selectedCaseType.name
                                }}
                                formGroupTestId={'edit-application-premium-setting-case-type'}
                            />
                        :
                            null
                    }
                    {
                        selectedSubCaseType
                        ?
                            <FormGroup
                                labelSize={"col-sm-3"}
                                inputSize={"col-sm-6"}
                                label={CONTENT_STRINGS.SUB_CASE_TYPE}
                                variant={FORM_GROUP_VARIANTS.PLAIN}
                                inputProps={{
                                    id: 'selectedSubCaseType',
                                    name: 'selectedSubCaseType',
                                    label: selectedSubCaseType.name
                                }}
                                formGroupTestId={'edit-application-premium-setting-sub-case-type'}
                            />
                        :
                            null
                    }
                </form>

                <div className="row">
                    <div className="col-sm-12">
                        <HorizontalRule />
                    </div>
                </div>

                <form className="form-horizontal premiumSettingsWizard-formWrapper" onSubmit={handleSubmit}>
                    <NavigationBar
                        variant={WIZARD}
                        onNavItemSelect={() => null}
                        activeItemKey={currentStep.toString()}
                        navItems={navItems}
                        stepCounter
                        navigationBarTestId={`application-premium-settings-wizard-nav-step-${currentStep}`}
                        id={`application-premium-settings-wizard-nav`}
                    />
                    {currentStep > 1
                    ?
                        <Link
                            label={CONTENT_STRINGS.BACK_TO + steps[currentStep - 2].name}
                            variant={TERTIARY}
                            arrowDirection={LEFT}
                            onClick={() => changeWizardStep('decrease')}
                            reversedArrow={true}
                            linkTestId={'edit-application-premium-setting-previous-step-top'}
                        />
                    :
                        null
                    }
                    <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
                        <div>
                            <NavigationContent>
                                <Step1
                                    caseStages={caseStages}
                                    handleCaseStagesSelectMultipleChange={handleCaseStagesSelectMultipleChange}
                                    handleCaseStagesCheckedState={handleCaseStagesCheckedState}
                                    currentStep={currentStep}
                                    stepMessages={premiumSettingsWizard.stepMessages}
                                    showNonContingentToggle={showNonContingentToggle}
                                    isPercentagePremium={isPercentagePremium}
                                    hasNonContingentPremium={hasNonContingentPremium}
                                    handleToggleNonContingent={handleToggleNonContingent}
                                    handleNonContingentCaseStagesChange={handleNonContingentCaseStagesChange}
                                    handleNonContingentCaseStagesCheckedState={handleNonContingentCaseStagesCheckedState}
                                    nonContingentLocked={nonContingentLocked}
                                />
                                <Step2
                                    currentStep={currentStep}
                                    getEndDamageBands={getEndDamageBands}
                                    getStartDamageBands={getStartDamageBands}
                                    setDamageBand={setDamageBand}
                                    removeDamageBand={removeDamageBand}
                                    getDamageBandName={getDamageBandName}
                                    damageBands={premiumSettingsWizard.damageBands}
                                    changeStoreSettings={changeStoreSettings}
                                    openDamageBandModal={premiumSettingsWizard.openDamageBandModal}
                                    sortDamageBands={sortDamageBands}
                                    stepMessages={premiumSettingsWizard.stepMessages}
                                />
                                <Step3
                                    step3WarningMsg={premiumSettingsWizard.step3WarningMsg}
                                    solicitorsList={premiumSettingsWizard.solicitorsList}
                                    removeSolicitor={removeSolicitor}
                                    addSolicitor={addSolicitor}
                                    lawsysFirms={lawsysFirms}
                                    openSolicitorModal={premiumSettingsWizard.openSolicitorModal}
                                    changeStoreSettings={changeStoreSettings}
                                    changeLawsysFirmState={changeLawsysFirmState}
                                    currentStep={currentStep}
                                    onSuggestionSelected={onSuggestionSelected}
                                    onSuggestionChange={onSuggestionChange}
                                    stepMessages={premiumSettingsWizard.stepMessages}
                                    solicitorGroupAragProviderId={solicitorGroupAragProviderId}
                                    commissionAddDisabled={commissionAddDisabled}
                                />
                                <SharedStep4
                                    isPercentagePremium={isPercentagePremium}
                                    recoverableRatePercentage={premiumSettingsWizard.recoverableRatePercentage}
                                    changeStoreSettings={changeStoreSettings}
                                    validationMessage={validationMessage}
                                    currentStep={currentStep}
                                    topHeader={topHeader}
                                    groups={groups}
                                    columns={editableColumns}
                                    data={data}
                                    verticalHeaders={verticalHeaders}
                                    stepMessages={premiumSettingsWizard.stepMessages}
                                    outerVerticalHeaders={outerVerticalHeaders}
                                    decimalErrors={decimalErrors}
                                    checkDecimal={checkDecimal}
                                />
                                <Step5
                                    isApplicationPremium={isApplicationPremium}
                                    premiumSettingTypeCustom={premiumSettingTypeCustom}
                                    isPercentagePremium={isPercentagePremium}
                                    validationMessageStep5={premiumSettingsWizard.validationMessageStep5}
                                    limitOfIndemnity={premiumSettingsWizard.limitOfIndemnity}
                                    decimalErrors={decimalErrors}
                                    checkDecimal={checkDecimal}
                                    validFrom={premiumSettingsWizard.validFrom}
                                    validUntil={premiumSettingsWizard.validUntil}
                                    changeStoreSettings={changeStoreSettings}
                                    currentStep={currentStep}
                                    notes={premiumSettingsWizard.notes}
                                    endorsements={premiumSettingsWizard.endorsements}
                                    comments={premiumSettingsWizard.comments}
                                    selectedCoverageType={selectedCoverageType}
                                    selectedDeductible={selectedDeductible}
                                    selectedEndorsement={selectedEndorsement}
                                    coveragesOptions={coveragesOptions}
                                    deductiblesOptions={deductiblesOptions}
                                    endorsementsOptions={endorsementsOptions}
                                    stepMessages={premiumSettingsWizard.stepMessages}
                                />
                                <SharedStep6
                                    badResponseMsg={premiumSettingsWizard.badResponseMsg}
                                    posting={premiumSettingsWizard.posting}
                                    limitOfIndemnity={premiumSettingsWizard.limitOfIndemnity}
                                    recoverableRatePercentage={premiumSettingsWizard.recoverableRatePercentage}
                                    notes={premiumSettingsWizard.notes}
                                    endorsements={premiumSettingsWizard.endorsements}
                                    comments={premiumSettingsWizard.comments}
                                    currentStep={currentStep}
                                    displayedCoverageType={displayedCoverageType}
                                    displayedDeductible={displayedDeductible}
                                    displayedEndorsement={displayedEndorsement}
                                    isApplicationPremium={isApplicationPremium}
                                    isPercentagePremium={isPercentagePremium}
                                    topHeader={topHeader}
                                    groups={groups}
                                    columns={columns}
                                    data={data}
                                    verticalHeaders={verticalHeaders}
                                    patching={premiumSettingsWizard.patching}
                                    appPremiumSettingsIndicator={appPremiumSettingsIndicator}
                                    showTable={showTable}
                                    stepMessages={premiumSettingsWizard.stepMessages}
                                    loiTestId={wizardLoiTestId}
                                    notesTestId={wizardNotesTestId}
                                    commentsTestId={wizardCommentsTestId}
                                    endorsementsTestId={wizardEndorsementsTestId}
                                    tableTestId={wizardTableTestId}
                                    outerVerticalHeaders={outerVerticalHeaders}
                                    validFromLabel={validFromLabel}
                                    coverageTestId={wizardCoverageTestId}
                                    deductiblesTestId={wizardDeductiblesTestId}
                                />
                            </NavigationContent>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                {currentStep <= 6
                                ?
                                    <div style={{display: 'flex', flexDirection: 'column', alignContent: 'center', gap: '10px'}}>
                                        <div style={{display: 'flex', flexDirection: 'row', alignContent: 'center', gap: '10px'}}>
                                            <div className='btn-wrapper'>
                                                <Button
                                                    type={SUBMIT}
                                                    variant={PRIMARY}
                                                    label={currentStep === 6
                                                        ? (premiumSettingsWizard.isEditMode
                                                            ? applicationPremiumSaveButtonLabel
                                                                ? applicationPremiumSaveButtonLabel
                                                                : CONTENT_STRINGS.UPDATE_PREMIUM_SETTING
                                                            : CONTENT_STRINGS.CREATE_PREMIUM_SETTING)
                                                        : CONTENT_STRINGS.NEXT_STEP
                                                    }
                                                    buttonTestId={'edit-application-premium-setting-next-step'}
                                                    arrowDirection={RIGHT}
                                                    disabled={premiumSettingsWizard.posting || premiumSettingsWizard.patching}
                                                />
                                            </div>
                                            <div className={'btn-wrapper'}>
                                                <Button
                                                    onClick={() => {
                                                        isApplicationPremium
                                                        ?
                                                            applicationPremiumCancelHandler()
                                                        :
                                                            handleCancelWizard();
                                                    }}
                                                    variant={QUATERNARY}
                                                    label={CONTENT_STRINGS.CANCEL}
                                                    buttonTestId={'edit-application-premium-setting-cancel'}
                                                    arrowDirection={RIGHT}
                                                />
                                            </div>
                                        </div>
                                        {currentStep > 1
                                        ?
                                            <Link
                                                label={CONTENT_STRINGS.BACK_TO + steps[currentStep - 2].name}
                                                variant={TERTIARY}
                                                arrowDirection={LEFT}
                                                onClick={() => changeWizardStep('decrease')}
                                                reversedArrow={true}
                                                linkTestId={'edit-application-premium-setting-previous-step-bottom'}
                                            />
                                        :
                                            null
                                        }
                                    </div>
                                :
                                    null
                                }
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
};

export default PremiumSettingsWizard;